var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityConnectSolid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_538_17205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.332 8.0004H9.43203C8.46179 7.98702 7.51731 8.31269 6.76151 8.92122C6.00572 9.52975 5.48601 10.383 5.29203 11.3337H1.33203V12.6671H5.28536C5.47594 13.6207 5.99565 14.4771 6.75364 15.0864C7.51164 15.6957 8.45968 16.0192 9.43203 16.0004H11.332V8.0004Z",
    fill: "#00A86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8213 11.3339C18.6269 10.3809 18.1052 9.52592 17.3467 8.91712C16.5881 8.30833 15.6405 7.98409 14.668 8.0006H12.668V16.0006H14.668C15.6403 16.0195 16.5884 15.6959 17.3464 15.0866C18.1044 14.4773 18.6241 13.6209 18.8146 12.6673H22.668V11.3339H18.8213Z",
    fill: "#00A86B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_538_17205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityConnectSolid2);
export default __webpack_public_path__ + "static/media/clarity_connect-solid 2.a349c1983dd2ba3327202d335e8b1c3b.svg";
export { ForwardRef as ReactComponent };